export default __webpack_public_path__ + "static/fire1-8f7b5e083312941665f5325c358d9274.png";